export default "__VITE_PUBLIC_ASSET__6dd246a3__"